module.exports = __webpack_public_path__ + "img/air-china.edfcdeb6.jpg";